<template>
  <div class="base-switch">
    <h2 class="base-switch__title"> {{ label }} </h2>
    <label class="switch">
      <span class="switch__off" :class="{ checked: value }"> OFF </span>
      <span class="switch__on"> ON </span>
      <input type="checkbox" :checked="value" :disabled="disabled" v-on="getListeners" v-bind="$attrs">
      <span class="slider round"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: "BaseSwitch",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getListeners() {
      return {
        ...this.$listeners,
        input: ({ target: { checked } }) => this.$emit("input", checked),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.base-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    margin: 0 1rem 0 0;
    font-size: 1rem;
    color: #868e96;
  }
}
.switch {
  position: relative;
  display: inline-block;
  width: 4rem;
  height: 2.125rem;

  &__off {
    top: 6px;
    position: relative;
    z-index: 5;
    font-size: 0.7rem;
    font-weight: 600;
    color: #868e96;

    &.checked {
      color: white;
    }
  }

  &__on {
    top: 6px;
    position: relative;
    z-index: 5;
    left: 3px;
    font-size: 0.7rem;
    font-weight: 600;
    color: #868e96;
  }
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked:not(:disabled) + .slider {
  background-color: blueviolet;
}

input:focus:not(:disabled) + .slider {
  box-shadow: 0 0 1px blueviolet;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>